var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"logo",class:`logo--${_vm.view}`,attrs:{"to":{ name: 'home' }}},[_c('img',{staticClass:"logo__image",attrs:{"src":_vm.image,"width":_vm.width,"height":_vm.height}})])
}
var staticRenderFns = []

export { render, staticRenderFns }